import WorkerApiService from "../workerApiServices";


class ProgressService extends WorkerApiService {

    constructor() {
        super('/api/progress')
    }

    getProgress(key){
        return this.get(`/getProgress/${key}`)
    }

    deleteProgress(key){
        return this.delete(`/deleteProgress/${key}`)
    }
}

export default ProgressService